import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { apiGetProcess } from "../../api/ApiProcess";
import ComponentBandeau from "../../components/layout/ComponentBandeau";
import ComponentMenu from "../../components/layout/ComponentMenu";
import BoardView from "../../components/public/process/BoardView";
import BoardViewMenu from "../../components/public/process/BoardViewMenu";
import ModalDetailsProcess from "../../components/public/process/ModalDetailsProcess";
import ComponentBreadcrumb from "../../components/public/process/ComponentBreadcrumb";
import ComponentSousmenu from "../../components/layout/ComponentSousmenu";
import ModalOrgunitsList from "../../components/public/process/ModalOrgunitsList";
import BlocFiltreFakeInGovernance from "../../components/public/governance/BlocFiltreFakeInGovernance";

const PageViewProcess = () => {
  let { id } = useParams();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [loading, setLoading] = useState(true);
  const [process, setProcess] = useState("");
  const [processToDisplay, setProcessToDisplay] = useState("");
  const [showModalDetails, setShowModalDetails] = useState(false);
  const [showModalOrgunitsList, setShowModalOrgunitsList] = useState(false);

  useEffect(() => {
    recupProcess();
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const recupProcess = async () => {
    const res = await apiGetProcess(ReduxInstance._id, id);
    if (res) {
      setProcess(res.data);
      setLoading(false);
    } else {
      console.log("error");
    }
  };

  const handleShowModalDetails = (proc) => {
    setProcessToDisplay(proc);
    setShowModalDetails(true);
  };

  const handleCloseModalDetails = () => {
    setProcessToDisplay("");
    setShowModalDetails(false);
  };

  const handleShowOrgunitsList = (proc) => {
    setProcessToDisplay(proc);
    setShowModalOrgunitsList(true);
  };

  const handleCloseModalOrgunitsList = () => {
    setProcessToDisplay("");
    setShowModalOrgunitsList(false);
  };

  return (
    <>
      <ComponentMenu menuActif="ingovernance" />
      <ComponentBandeau menu="inGovernance" />
      <div className="d-flex flex-nowrap sousMenuContainer mb-2 sousMenuContainerDefault">
        {ReduxInstance.sousMenus
          .filter((item) => item.parent === "inGovernance")
          .map((item, index) => (
            <ComponentSousmenu nom={item.nom} url={item.url} key={index} icone={item.icone} />
          ))}
      </div>
      <BlocFiltreFakeInGovernance />
      {!loading && (
        <div className="container-process-flow">
          <div
            style={{
              backgroundColor: "#F2F2F2",
              paddingLeft: 8,
              paddingTop: 2,
            }}
          >
            <ComponentBreadcrumb ReduxInstanceId={ReduxInstance._id} idProcess={id} />
          </div>
          <BoardViewMenu process={process} handleShowModal={handleShowModalDetails} />
          <BoardView
            nodes={process.view.filter((item) => item.type === "special")}
            edges={process.view.filter((item) => item.type !== "special")}
            handleShowDetailView={handleShowModalDetails}
            handleShowOrgunitsList={handleShowOrgunitsList}
          />
          <ModalDetailsProcess
            process={processToDisplay}
            show={showModalDetails}
            handleClose={handleCloseModalDetails}
          />
          <ModalOrgunitsList
            processId={processToDisplay._id}
            show={showModalOrgunitsList}
            handleClose={handleCloseModalOrgunitsList}
          />
        </div>
      )}
    </>
  );
};

export default PageViewProcess;
